import React, { FC } from 'react';
//import './styles.css';

const Breadcrumbs: FC<{ schooldetail: any }> = ({ schooldetail }) => {
    
    return (
        <div className="breadcrumbs">	
            <div className="container" >
                <ol>
                    <li><a href="/" className="active blue-color">Home</a> </li>
                    <li><a href="/school">Schools</a></li>
                    <li><a href="">{schooldetail.school_name}</a></li>
                </ol>
            </div>
	    </div>
    );
};

export default Breadcrumbs;